import { fun_PostAction, fun_Download } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 表格基础数据
      tableColumns: [
        {
          label: "图片类型",
          slotName: "pictureType"
        },
        {
          label: "图片",
          slotName: "picturePath"
        },
        {
          label: "操作",
          slotName: "cz"
        }
      ],
      // 列表数据
      tableData: [],
      // 图片预览dialog
      imgVisible: false,
      // 图片地址
      imgUrl: null
    };
  },

  // 接收父组件传递的数据
  props: {
    // 企业社会信用代码
    certificateHolderCode: {
      type: String
    },
    // 企业名称
    certificateHolderName: {
      type: String
    },
    // 页面名称
    pageName: {
      type: String
    },
    // 附件类型
    type: {
      type: String
    },
    // 数据编号
    sjbh: {
      type: String
    }
  },

  // 模板编译完成
  mounted() {},

  // 自定义方法
  methods: {
    /**
     * 打开弹窗
     * @author shuhua
     */
    fun_OpenDialog() {
      // 打开弹窗
      this.dialogVisible = true;
      // 获取列表一览数据
      this.fun_GetList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开加载
      this.loading = true;
      // 发起请求
      fun_PostAction(
        "/electronicLicense/list",
        {
          certificateHolderCode: this.certificateHolderCode,
          certificateHolderName: this.certificateHolderName,
          pageName: this.pageName,
          type: this.type,
          sjbh: this.sjbh
        },
        0
      ).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 表格数据
          this.tableData = data.corpPictureList;
          // 关闭加载
          this.loading = false;
        } else {
          // 关闭加载
          this.loading = false;
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 预览
     */
    fun_LookImg(e) {
      // 发起请求
      fun_Download("/electronicLicense/getPicture", {
        id: e
      }).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 存储this
          const _this = this;
          const data = new Blob([res.data]);
          this.fun_GetBlobToBase64(data).then(res => {
            // 打开弹窗
            this.imgVisible = true;
            // 回显图片
            _this.imgUrl = res;
          });
        }
      });
    },
    /**
     * 转为base64URL
     * @author 滕威
     */
    fun_GetBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        // 创建文件对象
        const reader = new FileReader();
        reader.onload = e => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(blob);
        reader.onerror = () => {
          reject(new Error("文件流异常！"));
        };
      });
    },
    /**
     * 导入的方法
     * @author shuhua
     */
    fun_import(e) {
      // 发起请求
      fun_PostAction("/electronicLicense/import", {
        id: this.sjbh,
        type: this.type,
        rId: e.picturePath,
        certificateTypeCode: e.pictureType,
        imageFormat: e.type
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 操作成功
          this.$message.success(msg);
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    }
  }
};
